import React, { useEffect, useState } from "react";
import DashboardHeader from "@/components/DashboardHeader";
import ToggleInput from "@/components/toggle/Toggle";
import { API_ROUTES } from "@/services/environment";
import { GET, POST } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router";
import { EditIcon, ShowIcon } from "@/constants/utils/svgs";
import { Link } from "react-router-dom";
import { FiEdit2 } from "react-icons/fi";
import { dateFunctionUS } from "@thdinc/hpf-shared";

interface User {
  first_name: string;
  last_name: string;
  roles: string;
  // Add other properties of the user object if available
}

const CompaniesList = () => {
  const navigate = useNavigate();

  const user = useAppSelector((store) => store.user)
  const { refreshToken } = useAppSelector((store) => store.user);
  const { getAllBusinesses, toggleBusinessStatus, toggleBusinessOptionStatus } = API_ROUTES;
  const [comapniesData, setComapniesData] = useState<Array<any>>([]);

  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    fetchData();
    // Clean-up function
    return () => {
      // Perform any clean-up (if needed)
    };
  }, []); // Empty dependency array to run effect only once on component mount

  const fetchData = async () => {
    // list of all the companies from the sever
    try {
      const result = await GET(getAllBusinesses, refreshToken);
      setComapniesData(result.data);
      setLoading(false);
    } catch (err) {
      console.log(err);
      // setCustomError('discount', JSON.stringify( err));
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = async (id: number, value: boolean) => {
    // in order to update status of company to pending or active state
    setLoading(true);
    const status = value ? "pending" : "active";
    const updatedItems = comapniesData.map((item) =>
      item.id === id ? { ...item, status: status } : item
    );
    setComapniesData([...updatedItems]);
    const body = {
      status: status,
    };
    try {
      await POST(toggleBusinessStatus + `/${id}`, body, refreshToken);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error updating item status:", error);
      // Handle error
    }
  };

  const handleBusinessOptionToggle = async (id: number, value: boolean) => {
    setLoading(true);
    const status = value;
    const updatedItems = comapniesData.map((item) =>
      item.id === id ? { ...item, application_access: status } : item
    );
    setComapniesData([...updatedItems]);
    const body = {
      application_access: status,
    };
    try {
      await POST(toggleBusinessOptionStatus + `/${id}`, body, refreshToken);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error updating item status:", error);
      // Handle error
    }
  };

  //company interface
  interface company {
    id: string;
    is_admin_added: boolean;
    is_cocktail_added: boolean;
    is_package_added: boolean;
  }
  const navigateToComplete = (item: company) => {
    // conditions to identify the pending step of profile completion
    if (!item.is_admin_added) {
      navigate(`/create-company/?id=${item.id}`, { state: { step: 2 } });
      return;
    }
    if (!item.is_package_added) {
      navigate(`/create-company/?id=${item.id}`, { state: { step: 3 } });
      return;
    }
    if (!item.is_cocktail_added) {
      navigate(`/create-company/?id=${item.id}`, { state: { step: 4 } });
      return;
    }
  };

  const getCompletion = (item: company) => {
    // get the progress of completeion in percentage using 4 steps
    const completionConditions = [
      true, //company detail is available
      item.is_admin_added,
      item.is_cocktail_added,
      item.is_package_added,
    ];
    const completedCount = completionConditions.filter(Boolean).length;
    const isCompleted = completedCount === completionConditions.length;
    return isCompleted
      ? 100
      : Math.round((completedCount / completionConditions.length) * 100);
  };

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const filteredCompanies = comapniesData.filter((item) => {
    // in order to search by company and admin name using search query
    const name = item.name.toLowerCase();
    const adminName = `${item.first_name} ${item.last_name}`.toLowerCase();
    const search = searchQuery.toLowerCase();
    return name.includes(search) || adminName.includes(search);
  });

  return (
    <div>
      {user.roles == "admin" ? (
        <div>
          <DashboardHeader title="Registered Businesses">
            <div className="flex sm:justify-end items-center min-w-32 w-full ">
              {/* <Button classes="px-2 text-sm sm:text-base px-2" onClick={() => navigate("/create-company/")}>
                Add New
              </Button> */}
              <div className="flex gap-2 items-center ">
                <input
                  type="search"
                  value={searchQuery}
                  onChange={handleSearch}
                  placeholder="Search by Name"
                  className=" w-full min-w-48 md:min-w-64 px-4 py-3  rounded-full    focus:outline-none  focus:ring-1 focus:ring-primary-red text-gray-600 "
                />
                <button className="sm:text-sm text-xs min-w-28   bg-black  text-white  rounded-full py-2 sm:px-4 px-2" onClick={() => navigate("/create-company/")}><span className="text-lg">+</span> Add New</button>
              </div>
            </div>
          </DashboardHeader>
          <div>

            <div className="relative overflow-x-auto rounded-lg mt-4 overflow-y-auto max-h-[700px]">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500 rounded-xl overflow-hidden ">
                <thead className="text-xs text-gray-700 uppercase bg-white  border-b">
                  <tr>
                    <th
                      scope="col"
                      className="px-5    py-5 font-semibold"
                    >
                      Sr#.
                    </th>
                    <th
                      scope="col"
                      className="px-5    py-5  font-semibold"
                    >
                      Business Name
                    </th>
                    <th
                      scope="col"
                      className="px-5    py-5 font-semibold"
                    >
                      Admin Name
                    </th>
                    <th
                      scope="col"
                      className="px-5    py-5 font-semibold "
                    >
                      Created Date
                    </th>
                    <th
                      scope="col"
                      className="px-5    py-5 font-semibold"
                    >
                      Last Modified
                    </th>
                    <th
                      scope="col"
                      className="px-5    py-5 font-semibold"
                    >
                      Completion %
                    </th>
                    <th
                      scope="col"
                      className="px-5    py-5 font-semibold"
                    >
                      Show on CF
                    </th>
                    <th
                      scope="col"
                      className="px-5    py-5 font-semibold"
                    >
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCompanies.map((item, index) => {
                    return (
                      <tr
                        key={index}
                        className="odd:bg-white even:bg-gray-50 even:border border-l border-r"
                      >
                        <th
                          scope="row"
                          className="max-w-5 px-5 py-4 font-medium text-gray-900 whitespace-nowrap"
                        >
                          {index + 1}
                        </th>
                        <td className="px-5 pl-2 py-4">{item?.name}</td>
                        <td className="px-5 py-4">
                          {item?.first_name || item.last_name
                            ? item?.first_name + " " + item?.last_name
                            : "N/A"}
                        </td>
                        <td className="px-5 py-4">
                          {dateFunctionUS(item?.created_at)}
                        </td>
                        <td className="px-5 py-4">
                          {dateFunctionUS(item?.updated_at)}
                        </td>
                        <td
                          className={`px-5 py-4 text-xs font-semibold min-w-10 md:min-w-28 ${getCompletion(item) == 100
                            ? "text-green-500"
                            : "text-red-500 cursor-pointer"
                            }`}
                        >
                          <div
                            onClick={() => {
                              navigateToComplete(item);
                            }}
                          >
                            {getCompletion(item) == 100
                              ? `Completed (${getCompletion(item)}%)`
                              : `Complete Now (${getCompletion(item)}%)`}
                          </div>
                        </td>
                        <td className="px-5 pl-2 py-4 text-center">
                          <ToggleInput
                            tooltipId={'my-tooltip-1'}
                            tooltipContent={'Customer Access'}
                            disabled={getCompletion(item) != 100}
                            data-testid={`toggleInput${index}`}
                            onChange={() =>
                              handleToggle(
                                item.id,
                                item.status == "active" ? true : false
                              )
                            }
                            checked={item.status == "active"}
                          />
                        </td>
                        <td className="px-5 py-4 flex gap-4 items-center">
                          {getCompletion(item) > 0 && (
                            <div
                              data-testid="routeToCompany"
                              onClick={() => {
                                navigate(`/create-company/?id=${item.id}`, {
                                  state: { isView: true },
                                });
                              }}
                              className=" text-primary-red cursor-pointer"
                            >
                              <ShowIcon />
                            </div>
                          )}
                          <Link
                            to={"/edit-company/" + item.id + "?tab=business"}
                          >
                            {getCompletion(item) === 100 ?
                              <div
                                className="cursor-pointer flex gap-3 bg-p-gray rounded-full p-2 "
                              >
                                <FiEdit2 size={14} />
                              </div> :
                              <div className="w-[30px]"></div>
                            }
                          </Link>
                          <ToggleInput
                            tooltipId={'my-tooltip-2'}
                            tooltipContent={'Admin Access'}
                            disabled={getCompletion(item) != 100}
                            data-testid={`toggleInput${index}`}
                            onChange={() =>
                              handleBusinessOptionToggle(
                                item.id,
                                !item.application_access
                              )
                            }
                            checked={item.application_access}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <p className="text-red-500">* Not Authorized</p>
        </div>
      )}
    </div>
  );
};

export default CompaniesList;
